import { useState, useEffect } from "react";
import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs";
import AddProductOption from "./AddProductOption";
import { CheckInput } from "../kits/Inputs/Inputs";
import { PlusCircle, DeleteIcon, TickIcon, CloseIcon } from "../kits/Icons";
import CustomButton from "../kits/button/CustomButton";
import { swalFunc } from "../../utils/helperFunction";
import "./SingleProduct.scss";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { translateToReactSelect } from "../../utils/helperFunction";
import useAxios from "../../services/useAxios";
import EditModalOrderOption from "./EditModalOrderOption";
import OrderOptionCheckList from "./OrderOptionCheckList";
import ToastCustomize from "../kits/ToastCustomize";

export default function OrderProductFieldTab({
  // optionAnswerList,
  answerType,
  productId,
  tabClickList,
  // orderOptionList,
  // orderOptionsApi,
}) {
  const priceType = [
    { value: "-1", label: "بی تاثیر" },
    { value: "1", label: "درصد" },
    { value: "2", label: "مبلغ" },
  ];
  const [orderOptionList, setOrderOptionList] = useState([
    { value: -1, label: "ساخت آپشن سفارش" },
  ]);
  const [optionOrderAnswerList, setOptionOrderAnswerList] = useState([]);
  const { loadingFindOO, execute: findOptionOrder } = useAxios(
    "api/Find_OptionOrder"
  );
  const { loadingFind, execute: findOOption } = useAxios(
    "api/Find_OptionOrderValue"
  );
  const orderOptionsApi = async () => {
    let tempOptionAnswerList = [];
    await findOOption({
      conditions: `p_service_id/=/${productId}`,
      tbl_name: `INNER JOIN,OptionOrder,option_order_id,id`,
    }).then((result) => {
      let resultTemp = result;
      let temp = [];
      for (let i = 0; i < resultTemp.length; i++) {
        let check = temp.find((v) => {
          return v.options.option_order__id == resultTemp[i].option_order__id;
        });
        if (!check) {
          temp = [
            ...temp,
            {
              options: {
                option_order__id: resultTemp[i].option_order__id,
                p_service_id: resultTemp[i].p_service_id,
                title: resultTemp[i].title,
                params: JSON.parse(resultTemp[i].params),
              },
              values: [JSON.parse(resultTemp[i]?.value)],
            },
          ];
        } else {
          check.values.push(JSON.parse(resultTemp[i].value));
        }
      }
      tempOptionAnswerList = temp;
      setOptionOrderAnswerList(temp);
    });
    await findOptionOrder().then((result) => {
      let temp2 = reduceTwoArray(
        translateToReactSelect(false, result, "title", true),
        tempOptionAnswerList.map((o) => {
          return { value: o.options.option_order__id, label: o.options.title };
        })
      );
      setOrderOptionList([{ value: -1, label: "ساخت آپشن سفارش" }, , ...temp2]);
    });
  };
  const [orderOptionUpdater, setOrderOptionUpdater] = useState(false);
  const [errorTxt, setErrorTxt] = useState({ optionAnswer: "" });
  const [selectOption, setSelectOption] = useState({
    params: [],
    inputType: "",
    optionAnswer: [],
  });

  const [addNewAnswer, setAddNewAnswer] = useState({
    txt: "",
    show: false,
    error: "",
  });
  const { loading, execute: addOOption } = useAxios(
    "api/add_option_order_pservice_link"
  );

  const { loadingDelete, execute: deleteOOption } = useAxios(
    "api/remove_option_order_pservice_link"
  );

  const optionSelectHandler = (object) => {
    ErrorTextHandler("optionAnswer", "");
    if (object.value != -1) {
      let array = JSON.parse(object?.params);
      for (let i = 0; i < array.length; i++) {
        array[i] = {
          ...array[i],
          unit: "0",
          pricePerUnit: "",
          priceOnOrder: "",
          status: false,
        };
      }
      let temp = {
        ...object,
        optionAnswer: [],
        params: array,
      };

      setSelectOption(temp);
    } else setSelectOption(object);
  };
  const ErrorTextHandler = (name, value) => {
    setErrorTxt((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const optionAnswerHandler = (object, index) => {
    let temp = [...selectOption.params];
    temp = temp.map((v) => {
      if (v.index == index) {
        return { ...v, status: !object.status };
      } else return v;
    });
    // temp[index] = { ...temp[index], status: !temp[index].status };
    console.log("selectOption function", object, index, temp);

    setSelectOption((prev) => {
      return { ...prev, params: temp };
    });
  };
  const priceHandler = (index, object) => {
    let temp = [...selectOption.params];
    temp = temp.map((v) => {
      if (v.index == index) {
        return { ...v, ...object };
      } else return v;
    });
    // temp[index] = { ...temp[index], ...object };
    console.log("test data", temp);
    setSelectOption((prev) => {
      return { ...prev, params: temp };
    });
  };
  // const priceHandler = (index, object) => {
  //   let temp = { ...selectOption };
  //   console.log("test test ???", temp);
  //   // temp.params[index][name] = value;
  //   temp.params[index] = { ...temp.params[index], ...object };

  //   setSelectOption(temp);
  // };
  const arrayContainObject = (array, object) => {
    let temp = array.findIndex((a) => a.index == object.index);

    let result;
    if (temp == -1) result = false;
    else result = true;

    return result;
  };
  const validationChooseOption = () => {
    let validate = [];

    let temp = selectOption.params;

    for (let i = 0; i < temp.length; i++) {
      if (
        temp[i].status == true &&
        temp[i].unit != "" &&
        (temp[i].priceOnOrder != "" || temp[i].priceOnOrder == 0) &&
        (temp[i].pricePerUnit != "" || temp[i].pricePerUnit == 0)
        //    ||
        // temp[i].status == false
      ) {
        validate.push(true);
      }
    }
    if (validate.length > 0 && validate.findIndex((v) => v == false) == -1) {
      ErrorTextHandler("optionAnswer", "");
      return true;
    } else {
      ErrorTextHandler("optionAnswer", "لطفا برای این آپشن جواب انتخاب کنید!");
      return false;
    }
  };

  const addOptionToOptionList = () => {
    let temp = {
      value: selectOption.params
        .filter((v) => v.status == true)
        .map((v) => JSON.stringify(v))
        .join("@@"),
      p_service_id: productId,
      option_order_id: selectOption.value,
    };

    addOOption(temp).then((result) => {
      if (result.status == 1) {
        orderOptionsApi();
        ToastCustomize({
          mainText: "آپشن با موفقیت اضافه شد!",
          duration: 2000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        ToastCustomize({
          mainText: "متاسفانه مشکلی پیش آمده است، دوباره تلاش کنید.!",
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
    // let temp = [...optionAnswerList, selectOption];

    // let newOption = reduceTwoArray(orderOptionList, temp);
    // setOrderOptionList(newOption);
    // ------
    setSelectOption({
      params: [],
      inputType: "",
      optionAnswer: [],
    });
  };
  const reduceTwoArray = (bigArray, smallArray) => {
    let a = bigArray.filter((b) => !smallArray.find((s) => b.value == s.value));
    return a;
  };

  const { loadingUpdateAnswer, execute: UpdateOrderOptionAnswer } = useAxios(
    "api/Update_OptionOrder"
  );
  const EditOrderOption = (id, params) => {
    let newParams = JSON.stringify(params);
    let update = orderOptionList.filter((o) => o.value == selectOption.value);
    console.log(newParams);
    UpdateOrderOptionAnswer({
      conditions: `id/=/${id}`,
      keyvalues: `params,[{"name":"کلی","index":1,"edit":false,"unit":"0","pricePerUnit":"","priceOnOrder":"","status":false},{"name":"uij"}]`,
    }).then((result) => {
      if (result.status == 1) {
        orderOptionsApi();
      }
    });
  };
  useEffect(() => {
    if (tabClickList.includes(2)) orderOptionsApi();
  }, [tabClickList]);
  // useEffect(() => {
  //   findOptionOrder().then((result) =>
  //     setOrderOptionList([
  //       { value: -1, label: "ساخت آپشن سفارش" },
  //       ,
  //       ...translateToReactSelect(false, result, "title", true),
  //     ])
  //   );
  // }, [orderOptionUpdater]);

  console.log("test edit parent ", selectOption);
  return (
    <div className="m-2 order-option-field">
      <div className="d-flex">
        {" "}
        <ReactSelect
          title="انتخاب یا ساخت آپشن سفارش"
          itemsList={orderOptionList}
          inputContainer="flex-grow-1"
          inputSize="lg"
          inputValue={selectOption}
          onChangeFunc={(e, action) => {
            if (action.action == "select-option") optionSelectHandler(e);
            else if (action.action == "clear")
              setSelectOption({
                params: [],
                inputType: "",
                optionAnswer: [],
              });
          }}
          isClearable={true}
        />
        <div
          className="col-md-5"
          style={{ display: addNewAnswer.show ? "block" : "none" }}
        >
          {" "}
          <CustomInput
            label="پاسخ جدید"
            inputSize="lg"
            type="text"
            inputContainer=" mx-1"
            inputValue={addNewAnswer.txt}
            onChangeFunc={(e) =>
              setAddNewAnswer((prev) => {
                return { ...prev, txt: e.target.value };
              })
            }
            textErr={addNewAnswer.error}
          />
        </div>
        {/* {selectOption?.value != -1 &&
          selectOption?.value != undefined &&
          (!addNewAnswer.show ? (
            <div
              className="align-self-center mt-3 cursor-pointer px-1"
              onClick={() => {
                setAddNewAnswer((prev) => {
                  return { ...prev, show: true };
                });
                setAddNewAnswer((prev) => {
                  return { ...prev, txt: "", error: "" };
                });
              }}
            >
              <PlusCircle />
            </div>
          ) : (
            <div className="d-flex align-self-center mt-3 cursor-pointer px-1">
              <div
                onClick={() => {
                  if (addNewAnswer.txt == "") {
                    setAddNewAnswer((prev) => {
                      return { ...prev, error: "لطفا پاسخی انتخاب کنید" };
                    });
                  } else {
                    EditOrderOption(selectOption.value, [
                      ...selectOption.params,
                      { name: addNewAnswer.txt },
                    ]);
                    setAddNewAnswer((prev) => {
                      return { ...prev, show: false };
                    });
                  }
                }}
              >
                <TickIcon />
              </div>
              <div
                onClick={() => {
                  setAddNewAnswer((prev) => {
                    return { ...prev, show: false };
                  });
                }}
              >
                <CloseIcon />
              </div>
            </div>
          ))} */}
      </div>

      {selectOption.value == -1 ? (
        <div
          className="mx-1 p-2 rounded shadow"
          style={{ border: "1px dashed" }}
        >
          <AddProductOption
            answerTypes={answerType}
            optionType="order"
            setUpdater={setOrderOptionUpdater}
            productOptionsApi={orderOptionsApi}
          />
        </div>
      ) : selectOption?.params?.length > 0 ? (
        <div>
          {console.log(
            "selectOption",
            selectOption.params.filter((t) => t.status == true)
          )}
          <div className="option-list">
            <OrderOptionCheckList
              data={selectOption}
              selected={selectOption.params.filter((t) => t.status == true)}
              optionAnswerHandler={optionAnswerHandler}
              priceType={priceType}
              priceHandler={priceHandler}
            />
          </div>
          {errorTxt.optionAnswer != "" && (
            <div className="validate-style ">{errorTxt.optionAnswer}</div>
          )}
          <div className="d-flex">
            <div className="d-flex justify-content-end w-100">
              <div
                className=""
                onClick={() => {
                  if (productId == "create") {
                    ToastCustomize({
                      mainText: "ابتدا مشخصات اولیه را ثبت کنید!",
                      duration: 4000,
                      toastType: "danger",
                      color: "danger",
                      position: "top-center",
                      hasHeader: false,
                    });
                  } else {
                    if (validationChooseOption()) {
                      console.log("submit", true);
                      addOptionToOptionList();
                    } else console.log("submit", false);
                  }
                }}
              >
                <CustomButton color="success">
                  افزودن آپشن به محصول
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      {optionOrderAnswerList?.length > 0 ? (
        <div className="my-3 mx-4">
          <div className="my-3 fw-bold fs-5"> آپشنهای محصول:</div>
          <ul>
            {" "}
            {optionOrderAnswerList?.map((o, i) => {
              return (
                <div className="d-flex align-items-center">
                  {" "}
                  {/* <img src={o.path} style={{ width: 25, height: 25 }} />{" "} */}
                  <li
                    key={`product-option-list-${i}`}
                    style={{
                      listStyleType: "disclosure-closed",
                      listStylePosition: "outside",
                    }}
                    className="my-3 ms-4"
                  >
                    <span className="fw-bold ">
                      {" "}
                      {o?.options.title}:&nbsp;&nbsp;{" "}
                    </span>

                    {o?.values.map((a, ai) => {
                      return (
                        <span
                          key={`product-option-list-item-${ai}`}
                          style={{ lineHeight: 1.6 }}
                        >
                          {a.name}(تاثیر در قیمت هر آیتم:
                          {priceType.filter((p) => p.value == a.unit)[0]
                            ?.value != -1 && addCommas(a.pricePerUnit)}
                          {priceType.filter((p) => p.value == a.unit)[0]?.label}
                          ، تاثیر در قیمت سفارش:{addCommas(a.priceOnOrder)}
                          تومان)
                          {ai < o.values.length - 1 ? "," : ""}
                        </span>
                      );
                    })}
                    <span className="d-inline-block mt-2 ms-5">
                      <div className="d-flex">
                        <div
                          onClick={() =>
                            swalFunc(
                              `آیا از حذف ${o?.options.title} مطمئن هستید؟`,
                              () =>
                                deleteOOption({
                                  option_order_id: o.options.option_order__id,
                                  p_service_id: productId,
                                }).then((result) => {
                                  if (result.status == 1) {
                                    orderOptionsApi();
                                  }
                                }),
                              "warning"
                            )
                          }
                        >
                          <DeleteIcon
                            color="white"
                            containerIconClassName="delete-icon rounded p-1 cursor-pointer"
                          />
                        </div>

                        <EditModalOrderOption
                          data={{ ...o.options, values: o.values }}
                          priceType={priceType}
                          orderOptionsApi={orderOptionsApi}
                        />
                      </div>
                    </span>
                  </li>
                </div>
              );
            })}
          </ul>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
